import { useState, useEffect } from 'react'
import { last } from 'lodash'

import { useInfinityScrollSimple } from 'hooks'
import { useGetReviewsQuery } from 'store/api/yay/user'
import { Review } from 'lib/_types'
import { appendList } from 'lib/helpers'

const useGetReviews = (userId: string, notActive = false) => {
  const [__fromId, __fromIdSet] = useState<string>('0')
  const [__reviews, __reviewsSet] = useState<Array<Review>>([])

  const reviewsRes = useGetReviewsQuery({
    userId,
    fromId: __fromId,
    notActive,
  })

  const loadMore = () => {
    __fromIdSet(last(__reviews)?.id?.toString?.())
  }

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore,
  })

  useEffect(() => {
    __reviewsSet((prevState) => {
      return appendList(prevState, reviewsRes?.currentData?.reviews)
    })
  }, [reviewsRes])

  return {
    isLoading: reviewsRes?.isFetching,
    shouldLoadMore: reviewsRes?.currentData?.reviews?.length > 0,
    combinedResults: __reviews,
    pinnedReviews: reviewsRes?.data?.pinned_reviews,
    onLoadMore: loadMore,
    loadMoreRef,
  }
}

export default useGetReviews
